import React from 'react'
import PropTypes from 'prop-types'
import {Helmet} from 'react-helmet'
import {Col, Container, Row} from 'reactstrap'

import Logo from 'components/Logo'
import Help from 'components/Help'

const NotFound = ({pageTitle, text, title, hideLogo, containerClassName}) => (
  <div className={containerClassName}>
    <Helmet>
      <title>{pageTitle}</title>
    </Helmet>
    <Container>
      <Row className="justify-content-center">
        <Col md="6">
          <div className="clearfix">
            {!hideLogo && (
              <p>
                <Logo />
              </p>
            )}
            <h1 className="float-left display-3 mr-4 d-none d-md-block">404</h1>
            <h4 className="pt-3">{title}</h4>
            <p className="float-left">{text}</p>
            <p className="float-left">
              <Help />
            </p>
          </div>
        </Col>
      </Row>
    </Container>
  </div>
)

NotFound.defaultProps = {
  text: 'Leider können wir diese Seite momentan nicht finden.',
  title: 'Oops!',
  hideLogo: false,
  containerClassName: 'app flex-row align-items-center',
  pageTitle: 'Seite nicht gefunden',
}

NotFound.propTypes = {
  containerClassName: PropTypes.string,
  hideLogo: PropTypes.bool,
  pageTitle: PropTypes.string,
  text: PropTypes.node,
  title: PropTypes.node,
}

export default NotFound
